import { AbstractControl } from '@angular/forms';
import { SinUtils } from '../utils/sin-utils';

export function sinValidator(control: AbstractControl) {
  const sin = control.value;
  if (sin === null || sin === '' || typeof sin !== 'string') {
    return null;
  }
  return SinUtils.isValidSIN(sin) ? null : { invalidSin: true };
}
